import startOfDay from 'utils/dates/startOfDay';
import isBefore from 'utils/dates/isBefore';

export default function getMaxAvailableEndDate(defaultEndDate: Date) {
  const today = startOfDay(new Date());

  return isBefore(today, defaultEndDate) ? today : defaultEndDate;
}
